import React, { useState } from "react"
import "./coop.sass"
import { defaultIntl, Slider } from "../../utils"

// images
import picg from "../../images/partner/cooper/baiyulan.jpg"
import picd from "../../images/partner/cooper/bigmao.jpg"
import pich from "../../images/partner/cooper/cafe.jpg"
import picb from "../../images/partner/cooper/meetyou.jpg"
import picc from "../../images/partner/cooper/oldtast.jpg"
import pice from "../../images/partner/cooper/tea.jpg"
import picj from "../../images/partner/cooper/yiguoduan.jpg"
import picf from "../../images/partner/cooper/yipinxiang.jpg"
import pici from "../../images/partner/cooper/yun.jpg"
import pica from "../../images/partner/cooper/zenq.jpg"

const SliderList = (intl = defaultIntl) => [
  <div className="columns is-vcentered">
    <div className="column text">
      <div className="text-content">
        <p>{intl.formatMessage({ id: "partner.coop.a.desc" })}</p>
        <p className="teller">{intl.formatMessage({ id: "partner.coop.a.title" })}</p>
      </div>
    </div>
    <div className="column img">
      <img src={pica} alt="" />
    </div>
  </div>,
  <div className="columns is-vcentered">
    <div className="column text">
      <div className="text-content">
        <p>{intl.formatMessage({ id: "partner.coop.b.desc" })}</p>
        <p className="teller">{intl.formatMessage({ id: "partner.coop.b.title" })}</p>
      </div>
    </div>
    <div className="column img">
      <img src={picb} alt="" />
    </div>
  </div>,
  <div className="columns is-vcentered">
    <div className="column text">
      <div className="text-content">
        <p>{intl.formatMessage({ id: "partner.coop.c.desc" })}</p>
        <p className="teller">{intl.formatMessage({ id: "partner.coop.c.title" })}</p>
      </div>
    </div>
    <div className="column img">
      <img src={picc} alt="" />
    </div>
  </div>,
  <div className="columns is-vcentered">
    <div className="column text">
      <div className="text-content">
        <p>{intl.formatMessage({ id: "partner.coop.d.desc" })}</p>
        <p className="teller">{intl.formatMessage({ id: "partner.coop.d.title" })}</p>
      </div>
    </div>
    <div className="column img">
      <img src={picd} alt="" />
    </div>
  </div>,
  <div className="columns is-vcentered">
    <div className="column text">
      <div className="text-content">
        <p>{intl.formatMessage({ id: "partner.coop.e.desc" })}</p>
        <p className="teller">{intl.formatMessage({ id: "partner.coop.e.title" })}</p>
      </div>
    </div>
    <div className="column img">
      <img src={pice} alt="" />
    </div>
  </div>,
  <div className="columns is-vcentered">
    <div className="column text">
      <div className="text-content">
        <p>{intl.formatMessage({ id: "partner.coop.f.desc" })}</p>
        <p className="teller">{intl.formatMessage({ id: "partner.coop.f.title" })}</p>
      </div>
    </div>
    <div className="column img">
      <img src={picf} alt="" />
    </div>
  </div>,
  <div className="columns is-vcentered">
    <div className="column text">
      <div className="text-content">
        <p>{intl.formatMessage({ id: "partner.coop.g.desc" })}</p>
        <p className="teller">{intl.formatMessage({ id: "partner.coop.g.title" })}</p>
      </div>
    </div>
    <div className="column img">
      <img src={picg} alt="" />
    </div>
  </div>,
  <div className="columns is-vcentered">
    <div className="column text">
      <div className="text-content">
        <p>{intl.formatMessage({ id: "partner.coop.h.desc" })}</p>
        <p className="teller">{intl.formatMessage({ id: "partner.coop.h.title" })}</p>
      </div>
    </div>
    <div className="column img">
      <img src={pich} alt="" />
    </div>
  </div>,
]

export default ({ intl = defaultIntl }) => {
  const [slider, setSlider] = useState(null)
  const [current, setCurrent] = useState(0)
  const SliderSettings = {
    dots: false,
    infinite: true,
    speed: 500,
    autoplay: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    // fade: 1,
    afterChange: cur => {
      setCurrent(cur)
      if (cur === SliderList.length - 1) {
        setTimeout(() => {
          slider.slickGoTo(0)
        }, 1500)
      }
    },
  }

  const handlerSwitch = i => {
    let item = document.querySelector(".current")
    slider.slickGoTo(i)
    if (item) {
      item.classList.remove("current")
    }
  }

  return (
    <div className="partner-coop">
      <Slider {...SliderSettings} ref={slider => setSlider(slider)}>
        {SliderList(intl).map((slider, index) => {
          return (
            <div className="slide-item" key={index}>
              <div className="container">{slider}</div>
            </div>
          )
        })}
      </Slider>
      <div className="container" style={{ border: 0, overflow: "visible" }}>
        <div className="slider-controll">
          {SliderList(intl).map((s, i) => {
            const sliderClass = ["slider-indicator"]
            if (i === current) {
              sliderClass.push("current")
            }
            return <span className={sliderClass.join(" ")} onClick={() => handlerSwitch(i)} onMouseOver={() => handlerSwitch(i)} key={i} />
          })}
        </div>
      </div>
    </div>
  )
}
